// extracted by mini-css-extract-plugin
module.exports =  {"warning-container":"warning-container-_GJlx","warning-statement":"warning-statement-MQjVq","actions":"actions-IOe34","action":"action-t06kj","label":"label-PkwRv"};